import React from 'react'
import { styled } from 'linaria/react'
import { theme } from '../../Theme'

const BannerSkeletonContainer = styled.div`
   background-color: white;
   .page-hero-title {
      display: block;
      font-size: 1.5rem;
      font-weight: 500;
      padding: 3rem 0 1rem 0;

      ${theme.above.md} {
         font-size: 1.5rem;
         padding: 1.5rem 0 1rem 0;
      }

      ${theme.above.lg} {
         font-size: 2rem;
         padding: 3rem 0 0 0;
      }
   }
`

const SearchResultBannerSkeletonSmall = () => {
   return (
      <BannerSkeletonContainer>
         <div className="p-0 m-0">
            <div className="col-12 p-0 pb-32">
               <div className="px-128">
                  <h2 className="page-hero-title position-relative z-2 m-0">
                     <span className="placeholder placeholder-wave" style={{ width: '350px' }}></span>
                  </h2>
               </div>
            </div>
         </div>
      </BannerSkeletonContainer>
   )
}

export default SearchResultBannerSkeletonSmall
